/**
 * Hook de **asignación de talonario** (`POST /api/v1/talonarios/assign`).
 *
 * Envuelve `assignTalonario` en un `useMutation`. Tras éxito **invalida las
 * queries de talonarios** (`docs/frontend_conventions.md`, Datos): el estado de
 * los talonarios cambia (rango nuevo) y aparece una entrada en el historial, así
 * que se invalida la raíz `['talonarios']`. El gating de permiso
 * (`manage_talonarios`) lo decide la UI; aquí solo se ejecuta y se propaga el
 * `ApiError` (la pantalla traduce `{error_code, message}`).
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { assignTalonario } from "../api";
import type { AssignTalonarioBody, TalonarioStatus } from "../types";
import { TALONARIOS_ROOT_KEY } from "./queryKeys";

export function useAssignTalonario() {
  const queryClient = useQueryClient();

  return useMutation<TalonarioStatus, Error, AssignTalonarioBody>({
    mutationFn: (body) => assignTalonario(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TALONARIOS_ROOT_KEY });
    },
  });
}
